// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"fc49169b","453":"7191a882"}[chunkId] + ".chunk.js";
};